<template>
  <div class="devicesModel-list-page">
    <div class="global-header-wrap">
      <div class="devicesModel-header-left">
        <div class="left-part">
          <span>设备尺寸</span>
          <div class="listSearch">
            <el-input
              v-model="size"
              clearable
              @input="inputHandleSeach"
              @keyup.enter.native="search"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>设备型号</span>
          <div class="listSearch">
            <el-input
              v-model="model"
              clearable
              @input="inputHandleSeach"
              @keyup.enter.native="search"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <button class="global-button-style" @click="search()">
          {{ $t("commonMsg.search") }}
        </button>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'createDevicesModel' })"
        >
          <img src="@/assets/img/cmb_btn_add.png" />新增型号
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">型号总数：{{ total ? total : 0 }}</div>
      <div class="global-body-wrap">
        <AppTable
          :tableProps="tableProps"
          :tableData="tableData"
          @tableHandle="tableHandle"
        />
      </div>
      <Pagination
        :pageSize="paramsList.limit"
        :total="total"
        @pageNum="pageNum"
        @pageSize="pageSize"
      />
    </el-card>

    <transition name="fade">
      <addComponent
        v-if="addPopup"
        title="编辑"
        :ruleForm="ruleForm"
        :ruleProps="ruleProps"
        :rules="rules"
        @addEvn="editEvn"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";
import addComponent from "@/components/addPopup";

export default {
  name: "devicesModel",
  components: {
    AppTable,
    Pagination,
    addComponent
  },
  computed: {
    ...mapGetters(["addPopup"]),
    tableProps() {
      let tableProps = [
        {
          prop: "size",
          label: "尺寸"
        },
        {
          prop: "model",
          label: "型号"
        },
        {
          prop: "updatedAt",
          label: "更新日期"
        },
        {
          prop: "handle",
          label: this.$t("org.manage"),
          width: 220,
          btn: [this.$t("commonMsg.edit"), this.$t("commonMsg.del")]
        }
      ];
      return tableProps;
    },
    ruleProps() {
      let ruleProps = [
        {
          prop: "size",
          label: "尺寸"
        },
        {
          prop: "model",
          label: "型号"
        }
      ];
      return ruleProps;
    },
    rules() {
      let rules = {
        size: [{ required: true, message: "尺寸不能为空", trigger: "blur" }],
        model: [{ required: true, message: "型号不能为空", trigger: "blur" }]
      };
      return rules;
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      size: "",
      model: "",
      paramsList: { limit: 20, page: 1, sortBy: "updatedAt" },
      currentItem: null,
      ruleForm: {
        size: "",
        model: ""
      },
      timer: null
    };
  },
  methods: {
    async getDevicesModelList() {
      try {
        let res = await this.$http.getDevicesModelList(this.paramsList);
        this.total = res.data.count;
        this.tableData = res.data.results;
      } catch (error) {}
    },

    search() {
      this.paramsList.page = 1;
      this.size
        ? (this.paramsList.size = this.size)
        : delete this.paramsList.size;
      this.model
        ? (this.paramsList.model = this.model)
        : delete this.paramsList.model;

      this.getDevicesModelList();
    },
    inputHandleSeach() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.search();
      }, 1000);
    },

    tableHandle(obj) {
      if (obj.type === this.$t("commonMsg.edit")) {
        let { size, model } = (this.currentItem = obj.data.row);
        this.ruleForm = {
          size,
          model
        };
        this.$store.commit("windowHandle", "addPopup");
      } else if (obj.type === this.$t("commonMsg.del")) {
        this.delDevicesModel(obj.data.row._id);
      }
    },

    async editEvn(data) {
      try {
        await this.$http.updateDevicesModel(this.currentItem._id, data);
        this.getDevicesModelList();
        this.elMsg(this.$t("alertMsg.modifySuccess"), "success");
        this.$store.commit("windowHandle");
      } catch (error) {
        this.elMsg(this.$t("alertMsg.modifyFailure"), "error");
      }
    },

    async delDevicesModel(id) {
      try {
        await this.$http.delDevicesModel(id);
        this.getDevicesModelList();
        this.elMsg(this.$t("alertMsg.delSuccess"), "success");
      } catch (error) {
        this.elMsg(error.response.data.message, "error");
      }
    },

    pageNum(val) {
      this.paramsList.page = val;
      this.getDevicesModelList();
    },

    pageSize(size) {
      this.paramsList.limit = size;
      this.getDevicesModelList();
    }
  },
  mounted() {
    this.getDevicesModelList();
  }
};
</script>

<style lang="scss" scoped>
.global-header-wrap {
  padding: 10px 44px;
}
.global-button-style {
  margin-top: 20px;
  margin-left: 0;
}
.devicesModel-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .devicesModel-header-left {
    width: calc(100% - 120px);
    float: left;
  }
  .left-part {
    float: left;
    margin-right: 20px;
    .listSearch {
      .el-input {
        width: 150px;
        .search-icon {
          font-size: 22px;
          cursor: pointer;
        }
      }
    }
    > span {
      margin-right: 10px;
      font-size: 14px;
    }
    .global-button-style {
      margin: 0;
    }
  }
}
</style>
